export function getMaskPhone(phone:any) {
  const str = String(phone).replace(/\s/g, '');
  if (str.length <= 7) {
    return '*'.repeat(str.length);
  }
  const s = String(phone ?? '').trim()
  return s.slice(0,3) + '****' + s.slice(-4)
}



export function getMaskIdCard(idCard:any) {
  if (!idCard) {
    return '-';
  }
  const s = String(idCard ?? '').replace(/\s/g, '');
  if (s.length <= 10) {
    return '*'.repeat(s.length);
  }
  return s.slice(0,6) + '*'.repeat(s.length - 10) + s.slice(-4)
}

